import React from "react";

export class PrekiniSamoiskljucenje extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            samoiskljucenjeSesijaPorukaPrikazana: localStorage.getItem(this._porukaPrikaza), emailPoslan: false
        }


        this._porukaPrikaza = "samoiskljucenjeSesijaPorukaPrikazana";

        this.posaljiEmail = this.posaljiEmail.bind(this);
        this.zatvori = this.zatvori.bind(this);
    }

    posaljiEmail() {
        this.props.showLoadingFn(true);
        var that = this;
        casino.repos.prekidSamoiskljucenjaRepo.create().then(function () {
            that.props.showLoadingFn(false);
            that.setState({ emailPoslan: true });
        });
    }
    zatvori() {
        localStorage.setItem(this._porukaPrikaza, this.props.sesijaId);
        this.setState({ samoiskljucenjeSesijaPorukaPrikazana: this.props.sesijaId });
    }
    render() {

        // ako nije samo isključen onda nista
        if (!this.props.user || !this.props.user.samoIskljucen)
            return null;

        // prikazemo ako treba
        if (this.props.sesijaId && this.props.sesijaId != this.state.samoiskljucenjeSesijaPorukaPrikazana)
            return <div className="overlay">
                <div className="overlay--content">
                    <div className="margin-center max-width-40">
                        <div className="margin-bottom">
                            <span className="text-xlarge text-xbold">
                                Aktiviran je SuperPredah
                            </span>
                        </div>
                        <div className="margin-bottom-small">
                            <span className="text text-4">
                                SuperPredah ti je aktiviran.<br />
                            </span>
                        </div>
                        <div className="margin-bottom">
                            <span className="text text-4">
                                Ako imaš dodatnih pitanja ili želiš opozvati status pauze ili ograničenja, slobodno se obrati našoj korisničkoj podršci na <a href="mailto:ssport@supersport.hr" target="_top">ssport@supersport.hr</a>
                            </span>
                        </div>
                        <div className="margin-bottom ">
                            <br />
                        </div>
                        <div className={!this.state.emailPoslan ? '' : 'hidden'}>
                            <button className="as-block btn large fill blue margin-top-small" onClick={this.posaljiEmail}>POŠALJI ZAHTJEV ZA OPOZIV</button>
                        </div>
                        <div className={this.state.emailPoslan ? '' : 'hidden'}>
                            <div className="success-message text-left">
                                <span className="icon ico-check-indeterminate"></span><span>
                                    Zahtjev za aktivaciju uspješno poslan!
                               </span>
                            </div>
                        </div>
                        <div className="margin-bottom-small">
                            <br />
                        </div>
                        <div className={!this.state.emailPoslan ? '' : 'hidden'}>

                            <div className="ili"><div><span className="text-medium">ili</span></div></div>
                        </div>
                        <div className="margin-bottom-small">
                            <br />
                        </div>
                        <div className="margin-bottom">
                            <button className="link as-block text-medium" onClick={this.zatvori}><span>ZATVORI I NASTAVI</span></button>
                        </div>
                        <br />
                    </div>
                </div>
            </div>


        return null;
    }
};
